import { httpClient } from 'src/libraries/http.library';
import {
  RiskAssessmentPayloadSchema,
  IRiskAssessmentSchema,
} from 'src/models/risk-assessment.model';

const client = httpClient();

const services = {
  dataGET: async (requestId: number) => {
    return client.get(
      `/assessment/${requestId}`,
      {},
      RiskAssessmentPayloadSchema
    );
  },
  addPost: async (data: IRiskAssessmentSchema) => {
    return client.post(
      `/assessment/${data.requestId}`,
      data,
      RiskAssessmentPayloadSchema
    );
  },
  updatePut: async (data: IRiskAssessmentSchema) => {
    return client.put(
      `/assessment/${data.requestId}`,
      data,
      RiskAssessmentPayloadSchema
    );
  },
};

export default services;
